module.exports = __webpack_public_path__ + "static/media/Cross-blue.226b8b5f.svg";